export const ADMIN_LOGIN_MATCH_ERROR = 'Admin exists with such login';
export const ADMIN_EMAIL_MATCH_ERROR = 'Admin exists with such email';
export const TOTAL_NUMBER_OF_RECORDS_EXCEEDS_ERROR = 'total number of records exceeds';
export const TOTAL_NUMBER_OF_ADMINS_EXCEEDS_ERROR = 'admin maximum count limit has been reached';
